module.exports = __webpack_public_path__ + "static/img/downloadApp.4acd6b06.png";